// import house images
import House1 from './assets/img/houses/house1.png';
import House2 from './assets/img/houses/house2.png';
import House3 from './assets/img/houses/house3.png';
import House4 from './assets/img/houses/house4.png';
import House5 from './assets/img/houses/house5.png';
import House6 from './assets/img/houses/house6.png';
import House7 from './assets/img/houses/house7.png';
import House8 from './assets/img/houses/house8.png';
import House9 from './assets/img/houses/house9.png';
import House10 from './assets/img/houses/house10.png';
import House11 from './assets/img/houses/house11.png';
import House12 from './assets/img/houses/house12.png';


// import apartments images
import Apartment1 from './assets/img/apartments/a1.jpg';
import Apartment2 from './assets/img/apartments/a2.jpg';
import Apartment3 from './assets/img/apartments/a3.jpg';
import Apartment4 from './assets/img/apartments/a4.jpg';
import Apartment5 from './assets/img/apartments/a5.jpg';
import Apartment6 from './assets/img/apartments/a6.jpg';
import Apartment7 from './assets/img/apartments/a7.jpg';
import Apartment8 from './assets/img/apartments/a8.jpg';
import Apartment9 from './assets/img/apartments/a9.jpg';

// import agents images
import Agent1 from './assets/img/agents/agent1.png';
import Agent2 from './assets/img/agents/agent2.png';
import Agent3 from './assets/img/agents/agent3.png';
import Agent4 from './assets/img/agents/agent4.png';
import Agent5 from './assets/img/agents/agent5.png';
import Agent6 from './assets/img/agents/agent6.png';
import Agent7 from './assets/img/agents/agent7.png';
import Agent8 from './assets/img/agents/agent8.png';
import Agent9 from './assets/img/agents/agent9.png';
import Agent10 from './assets/img/agents/agent10.png';
import Agent11 from './assets/img/agents/agent11.png';
import Agent12 from './assets/img/agents/agent12.png';
import client1 from './assets/img/agents/agent1.png';
import client2 from './assets/img/agents/agent9.png';
import client3 from './assets/img/agents/agent3.png';
import client4 from './assets/img/agents/agent4.png';


  export const housesData = [
    {
      id: 1,
      type: 'House',
      name: 'House 1',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House1,
      country: 'United States',
      address: '7240C Argyle St. Lawndale, CA 90260',
      bedrooms: '4',
      bathrooms: '3',
      surface: '4200 ft',
      year: '2016',
      price: '230000',
      agent: {
        image: Agent1,
        name: 'Patricia Tullert',
        phone: '0123 456 78910',
      },
    },
    {
      id: 2,
      type: 'House',
      name: 'House 2',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House2,
      country: 'Canada',
      address: '798 Talbot St. Bridgewater, NJ 08807',
      bedrooms: '5',
      bathrooms: '3',
      surface: '4200 ft',
      year: '2016',
      price: '170000',
      agent: {
        image: Agent2,
        name: 'Daryl Hawker',
        phone: '0123 456 78910',
      },
    },
    {
      id: 3,
      type: 'House',
      name: 'House 3',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House3,
      country: 'United States',
      address: '2 Glen Creek St. Alexandria, VA 22304',
      bedrooms: '5',
      bathrooms: '3',
      surface: '4200 ft',
      year: '2016',
      price: '180000',
      agent: {
        image: Agent3,
        name: 'Amado Smith',
        phone: '0123 456 78910',
      },
    },
    {
      id: 4,
      type: 'House',
      name: 'House 4',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House4,
      country: 'Canada',
      address: '84 Woodland St. Cocoa, FL 32927',
      bedrooms: '5',
      bathrooms: '3',
      surface: '4200 ft',
      year: '2016',
      price: '200000',
      agent: {
        image: Agent4,
        name: 'Kaitlyn Gonzalez',
        phone: '0123 456 78910',
      },
    },
    {
      id: 5,
      type: 'House',
      name: 'House 5',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House5,
      country: 'United States',
      address: '28 Westport Dr. Warminster, PA 18974',
      bedrooms: '5',
      bathrooms: '3',
      surface: '4200 ft',
      year: '2015',
      price: '210000',
      agent: {
        image: Agent5,
        name: 'Grover Robinson',
        phone: '0123 456 78910',
      },
    },
    {
      id: 6,
      type: 'House',
      name: 'House 6',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House6,
      country: 'Canada',
      address: '32 Pawnee Street Butte, MT 59701',
      bedrooms: '5',
      bathrooms: '3',
      surface: '6200 ft',
      year: '2014',
      price: '220000',
      agent: {
        image: Agent6,
        name: 'Karen Sorensen',
        phone: '0123 456 78910',
      },
    },
    {
      id: 7,
      type: 'Apartament',
      name: 'Apartament 1',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: Apartment1,
      country: 'Canada',
      address: '65 Cloee Street Butte, MT 59701',
      bedrooms: '2',
      bathrooms: '1',
      surface: '1200 ft',
      year: '2012',
      price: '110000',
      agent: {
        image: Agent7,
        name: 'Jawhar Shamil Naser',
        phone: '0123 456 78910',
      },
    },
    {
      id: 8,
      type: 'Apartament',
      name: 'Apartament 2',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: Apartment2,
      country: 'United States',
      address: '20 Westport Dr. Warminster, PA 18974',
      bedrooms: '3',
      bathrooms: '1',
      surface: '1200 ft',
      year: '2011',
      price: '90000',
      agent: {
        image: Agent8,
        name: 'Juana Douglass',
        phone: '0123 456 78910',
      },
    },
    {
      id: 9,
      type: 'Apartament',
      name: 'Apartament 3',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: Apartment3,
      country: 'United States',
      address: '88 Woodland St. Cocoa, FL 32927',
      bedrooms: '2',
      bathrooms: '1',
      surface: '1100 ft',
      year: '2011',
      price: '83000',
      agent: {
        image: Agent9,
        name: 'Jerry Schenck',
        phone: '0123 456 78910',
      },
    },
    {
      id: 10,
      type: 'House',
      name: 'House 7',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House7,
      country: 'Canada',
      address: '7240C Argyle St. Lawndale, CA 90260',
      bedrooms: '5',
      bathrooms: '3',
      surface: '3200 ft',
      year: '2015',
      price: '117000',
      agent: {
        image: Agent10,
        name: 'Vera Levesque',
        phone: '0123 456 78910',
      },
    },
    {
      id: 11,
      type: 'House',
      name: 'House 8',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House8,
      country: 'Canada',
      address: '798 Talbot St. Bridgewater, NJ 08807',
      bedrooms: '5',
      bathrooms: '2',
      surface: '2200 ft',
      year: '2019',
      price: '145000',
      agent: {
        image: Agent11,
        name: 'Sofia Gomes',
        phone: '0123 456 78910',
      },
    },
    {
      id: 12,
      type: 'House',
      name: 'House 9',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House9,
      country: 'United States',
      address: '2 Glen Creek St. Alexandria, VA 22304',
      bedrooms: '4',
      bathrooms: '4',
      surface: '4600 ft',
      year: '2015',
      price: '139000',
      agent: {
        image: Agent12,
        name: 'Raymond Hood',
        phone: '0123 456 78910',
      },
    },
    {
      id: 13,
      type: 'House',
      name: 'House 10',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House10,
      country: 'Canada',
      address: '84 Woodland St. Cocoa, FL 32927',
      bedrooms: '5',
      bathrooms: '2',
      surface: '5200 ft',
      year: '2014',
      price: '180000',
      agent: {
        image: Agent1,
        name: 'Patricia Tullert',
        phone: '0123 456 78910',
      },
    },
    {
      id: 14,
      type: 'House',
      name: 'House 11',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House11,
      country: 'United States',
      address: '28 Westport Dr. Warminster, PA 18974',
      bedrooms: '5',
      bathrooms: '2',
      surface: '3200 ft',
      year: '2011',
      price: '213000',
      agent: {
        image: Agent2,
        name: 'Daryl Hawker',
        phone: '0123 456 78910',
      },
    },
    {
      id: 15,
      type: 'House',
      name: 'House 12',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House12,
      country: 'Canada',
      address: '32 Pawnee Street Butte, MT 59701',
      bedrooms: '4',
      bathrooms: '3',
      surface: '5200 ft',
      year: '2013',
      price: '221000',
      agent: {
        image: Agent3,
        name: 'Amado Smith',
        phone: '0123 456 78910',
      },
    },
    {
      id: 16,
      type: 'Apartament',
      name: 'Apartament 16',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: Apartment4,
      country: 'Canada',
      address: '32 Pawnee Street Butte, MT 59701',
      bedrooms: '2',
      bathrooms: '1',
      surface: '1300 ft',
      year: '2011',
      price: '80000',
      agent: {
        image: Agent4,
        name: 'Kaitlyn Gonzalez',
        phone: '0123 456 78910',
      },
    },
    {
      id: 17,
      type: 'Apartament',
      name: 'Apartament 17',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: Apartment5,
      country: 'United States',
      address: '28 Westport Dr. Warminster, PA 18974',
      bedrooms: '3',
      bathrooms: '1',
      surface: '1000 ft',
      year: '2012',
      price: '85000',
      agent: {
        image: Agent5,
        name: 'Grover Robinson',
        phone: '0123 456 78910',
      },
    },
    {
      id: 18,
      type: 'Apartament',
      name: 'Apartament 18',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: Apartment6,
      country: 'Canada',
      address: '84 Woodland St. Cocoa, FL 32927',
      bedrooms: '3',
      bathrooms: '1',
      surface: '1200 ft',
      year: '2010',
      price: '88000',
      agent: {
        image: Agent6,
        name: 'Karen Sorensen',
        phone: '0123 456 78910',
      },
    },

    {
      id: 19,
      type: 'House',
      name: 'House 19',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House7,
      country: 'Canada',
      address: '7240C Argyle St. Lawndale, CA 90260',
      bedrooms: '5',
      bathrooms: '3',
      surface: '3200 ft',
      year: '2015',
      price: '117000',
      agent: {
        image: Agent10,
        name: 'Vera Levesque',
        phone: '0123 456 78910',
      },
    },
    {
      id: 20,
      type: 'House',
      name: 'House 20',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House8,
      country: 'Canada',
      address: '5  St. Bridgewater, NJ 04117',
      bedrooms: '3',
      bathrooms: '2',
      surface: '2200 ft',
      year: '2019',
      price: '195000',
      agent: {
        image: Agent11,
        name: 'Sofia Gomes',
        phone: '0123 456 78910',
      },
    },
    {
      id: 21,
      type: 'House',
      name: 'House 21',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House9,
      country: 'United States',
      address: '2 Glen Creek St. Alexandria, VA 22304',
      bedrooms: '4',
      bathrooms: '4',
      surface: '4600 ft',
      year: '2015',
      price: '169000',
      agent: {
        image: Agent12,
        name: 'Raymond Hood',
        phone: '0123 456 78910',
      },
    },
    {
      id: 22,
      type: 'House',
      name: 'House 22',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House10,
      country: 'Canada',
      address: '84 Woodland St. Cocoa, FL 32927',
      bedrooms: '4',
      bathrooms: '2',
      surface: '5200 ft',
      year: '2014',
      price: '190000',
      agent: {
        image: Agent1,
        name: 'Patricia Tullert',
        phone: '0123 456 78910',
      },
    },
    {
      id: 23,
      type: 'House',
      name: 'House 23',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House11,
      country: 'United States',
      address: '28 Westport Dr. Warminster, PA 18974',
      bedrooms: '4',
      bathrooms: '2',
      surface: '3200 ft',
      year: '2011',
      price: '213000',
      agent: {
        image: Agent2,
        name: 'Daryl Hawker',
        phone: '0123 456 78910',
      },
    },
    {
      id: 24,
      type: 'House',
      name: 'House 24',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: House12,
      country: 'Canada',
      address: '32 Pawnee Street Butte, MT 59701',
      bedrooms: '4',
      bathrooms: '3',
      surface: '5200 ft',
      year: '2013',
      price: '221000',
      agent: {
        image: Agent3,
        name: 'Amado Smith',
        phone: '0123 456 78910',
      },
    },
    {
      id: 25,
      type: 'Apartament',
      name: 'Apartament 25',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: Apartment7,
      country: 'Canada',
      address: '45 Pawnee Street Butte, MT 59701',
      bedrooms: '2',
      bathrooms: '1',
      surface: '1300 ft',
      year: '2011',
      price: '80000',
      agent: {
        image: Agent4,
        name: 'Kaitlyn Gonzalez',
        phone: '0123 456 78910',
      },
    },
    {
      id: 26,
      type: 'Apartament',
      name: 'Apartament 26',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: Apartment8,
      country: 'United States',
      address: '49 Westport Dr. Warminster, PA 18974',
      bedrooms: '3',
      bathrooms: '1',
      surface: '1000 ft',
      year: '2012',
      price: '85000',
      agent: {
        image: Agent5,
        name: 'Grover Robinson',
        phone: '0123 456 78910',
      },
    },
    {
      id: 27,
      type: 'Apartament',
      name: 'Apartament 27',
      description:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet, illoat. Repudiandae ratione impedit delectus consectetur. Aspernaturvero obcaecati placeat ab distinctio unde ipsam molestias atqueratione delectus blanditiis nemo eius dignissimos doloremque quaealiquid maiores id tempore consequatur, quod pariatur saepe.',
      image: Apartment9,
      country: 'Canada',
      address: '96 Woodland St. Cocoa, FL 32927',
      bedrooms: '3',
      bathrooms: '1',
      surface: '1200 ft',
      year: '2010',
      price: '88000',
      agent: {
        image: Agent6,
        name: 'Karen Sorensen',
        phone: '0123 456 78910',
      },
    },
  ];


export const Testimonials =  [
  {
    id: 1,
    image: client1,
    client: 'Daniel Macler',
    text: "I couldn't be happier with the rental services provided by Estateland. They made the whole process so easy and stress-free. Their team was professional, responsive, and found me the perfect place to call home. I highly recommend their rental services to anyone in need of a great place to live.",
  },
  {
    id: 2,
    image: client2,
    client: 'Maria Aston',
    text: "I found my dream home! The intuitive interface and advanced features made searching and purchasing a property a delightful experience. I highly recommend this app to anyone looking for the perfect place to call home!",
  },
  {
    id: 3,
    image: client3,
    client: 'Austin Lincon',
    text: "The team at Estateland went above and beyond to help me sell my property. Their expertise and marketing strategies are top-notch. They managed to secure a great deal for me, and I couldn't be happier with the results. I would highly recommend Estateland for anyone looking to sell their property.",

  },
  {
    id: 4,
    image: client4,
    client: 'Keisha Lorenzo',
    text: "Estateland's property listing and sales services are exceptional. They have a deep understanding of the real estate market and provided me with invaluable insights throughout the selling process. Thanks to their guidance, I was able to sell my property quickly and at a great price. I am grateful for their professionalism and dedication.",

  }
]
